import styled from '@emotion/styled';
import { AnnouncementPanel, Typography } from '@innovamat/glimmer-components';
import { Trans } from 'react-i18next';
import { APP_PATHS, useNavigation } from '../../../navigation';

const StyledAnnouncementPanel = styled(AnnouncementPanel)`
  margin-right: 24px;
  width: auto;
`;

function YearUpgradeAnnouncementPanel(): JSX.Element {
  const { navigateInSameNavType } = useNavigation();
  return (
    <StyledAnnouncementPanel
      text={
        <Trans
          i18nKey="classroom.updatePeriod.announcement"
          components={{
            a: (
              <Typography.Link2
                onClick={() =>
                  navigateInSameNavType(APP_PATHS.CLASSROOM_STUDENTS_URL)
                }
              />
            ),
          }}
        />
      }
      type="imported"
      canClose={false}
    />
  );
}

export { YearUpgradeAnnouncementPanel };
